import Query from '../../components/Report';

export const query1 = new Query('discover-algo-comparison-dates');

export const query = new Query('global-min-max-date');
